// 활동 줄 중 키워드로 울린 것을 가른다(3차 F171).
//
// 활동 판(`activity_panel.tsx`)과 따로 둔 까닭: 불러오는 쪽(`Room`)은 첫 화면에 있는데, 판 모듈에서 이 함수를
// 가져오면 판 전체와 아이콘 여섯이 첫 청크로 끌려왔다(+2 kB).

import type { UserId } from '@maru/protocol'
import type { Act } from './activity_panel.tsx'

/**
 * 키워드로 울린 줄을 가려 낱말을 붙인다.
 *
 * 서버는 키워드를 멘션과 같은 배지로 올리고 활동에도 `mention` 으로 적는다. 그대로 "나를 멘션했어요" 라고
 * 말하면 부르지도 않은 사람이 부른 것이 된다(3차 F171). 미리보기에 나를(또는 모두·그룹을) 부른 자리가
 * 없고 글에 내 키워드가 있으면 키워드다. 미리보기가 없는 옛 줄은 그대로 둔다.
 */
export function mark_keywords(acts: readonly Act[], me: UserId, words: readonly string[]): Act[] {
  if (words.length === 0) return [...acts]
  return acts.map((act) => {
    if (act.kind !== 'mention' || act.preview === undefined || act.preview.length === 0) return act
    const called = act.preview.some(
      (s) =>
        (s.t === 'mention_user' && s.user === me) ||
        s.t === 'mention_all' ||
        s.t === 'mention_group',
    )
    if (called) return act
    const text = (act.text ?? '').toLowerCase()
    const word = words.find((w) => text.includes(w.toLowerCase()))
    return word === undefined ? act : { ...act, word }
  })
}
